import { render, staticRenderFns } from "./KegiatanPelayananKhusus.vue?vue&type=template&id=78c52c3d"
import script from "./KegiatanPelayananKhusus.vue?vue&type=script&lang=js"
export * from "./KegiatanPelayananKhusus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c52c3d')) {
      api.createRecord('78c52c3d', component.options)
    } else {
      api.reload('78c52c3d', component.options)
    }
    module.hot.accept("./KegiatanPelayananKhusus.vue?vue&type=template&id=78c52c3d", function () {
      api.rerender('78c52c3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananKhusus.vue"
export default component.exports